var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenModal = function SvgOpenModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M18.75 10.5a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 1-.75.75h-12a.75.75 0 0 1-.75-.75v-12A.75.75 0 0 1 5.25 6h7.5a.75.75 0 1 0 0-1.5h-7.5A2.25 2.25 0 0 0 3 6.75v12A2.25 2.25 0 0 0 5.25 21h12a2.25 2.25 0 0 0 2.25-2.25v-7.5a.75.75 0 0 0-.75-.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M21.75 1.5h-6a.75.75 0 1 0 0 1.5h4.192l-8.475 8.468A.752.752 0 0 0 12 12.753a.75.75 0 0 0 .533-.221L21 4.058V8.25a.75.75 0 1 0 1.5 0v-6a.75.75 0 0 0-.75-.75"
  })));
};
export default SvgOpenModal;